import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';

type Props = {
  classes: Object,
  children?: any,
  invert?: boolean,
};

type State = {};


class GroupContainerHeader extends React.Component {
  props: Props;
  state: State = {};

  static defaultProps = {
    children: undefined,
    invert: false,
  };

  render() {
    const {
      classes,
      children,
      invert,
    } = this.props;
    return (
      <div className={classNames(classes.header, { invert })}>
        {children}
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    header: {
      padding: [8, 12, 4, 12],
      height: 60,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flexShrink: 0,
      position: 'relative',
      borderBottom: {
        width: 1,
        style: 'solid',
        color: theme.color.basis6,
      },
      [theme.mediaQuery.desktopAndUp]: {
        padding: [10, 12, 4, 12],
      },
      '&.invert': {
        borderColor: theme.color.basis3,
      },
      [theme.mediaQuery.mobileOnly]: {
        height: 70,
      },
    },
  };
}

export default useSheet(applyStyles)(GroupContainerHeader);
